// src/hooks/useLocations.ts
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetcher } from "../lib/apiClient";
import type { UserForm } from "@/schemas/user/userFormSchema";
import type { SignInForm } from "@/schemas/user/signinFormSchema";
import { useAuth } from "./useAuth";
import { useRouter } from "@tanstack/react-router";

type UserFormWithId = UserForm & { id: number };

export function getUser() {
  return useQuery({
    queryKey: ["user"],
    queryFn: (): Promise<UserFormWithId[]> => fetcher("/api/user"),
  });
}

export function setUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: UserForm) =>
      fetcher("/api/user", {
        method: "POST",
        body: JSON.stringify(data),
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["user"] }),
  });
}

export function deleteUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: Number) =>
      fetcher("/api/user", {
        method: "DELETE",
        body: JSON.stringify({ id }),
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["user"] }),
  });
}

export function loginUser() {
  const queryClient = useQueryClient();
  const { login } = useAuth();
  const router = useRouter();
  return useMutation({
    mutationFn: (data: SignInForm) =>
      fetcher("/api/user/login", {
        method: "POST",
        body: JSON.stringify(data),
      }),
    onSuccess: (data) => {
      login(data);
      queryClient.invalidateQueries({ queryKey: ["user", "auth"] });
      router.navigate({ to: "/map/skopa" });
    },
    onError: (err: Error) => {
      console.error(err.message);
    },
  });
}
